require('./pages/index')
require('./pages/services')

require('./components/menu')